import {useEffect} from "react";
import {useSignal} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";

import { WEBBACK_V2_API, GROUPED_BY } from "@constants";
import {commonFiltersValue, groupedBy, isLoadingCommonFilters, isSystemBusy} from "@signals";
import { elementsInLoading, catalogueAnalyzerTabSelected } from "../../@signals";


export default function useCatalogueAnalyzerNumPerRetailerChart() {

	const isLoading = useSignal(false)
	const data = useSignal([])

	useEffect(() => {
		if (isLoadingCommonFilters.value) {
			isLoading.value = true
			data.value = []
			postSubmit(`${WEBBACK_V2_API}/catalogue/num-per-retailer`, { 
				...commonFiltersValue.value, groupedBy: catalogueAnalyzerTabSelected.value
			}).then(res => data.value = res)
			.catch(() => {
				isSystemBusy.value = true
				isLoadingCommonFilters.value = false
			}).finally(() => isLoading.value = false)
		}
	}, [isLoadingCommonFilters.value]);

	useEffect(() => {
		if (isLoading.value)
			elementsInLoading.value = [...elementsInLoading.value, 'numPerRetailer']
		else{
			elementsInLoading.value = elementsInLoading.value.filter(item => item !== 'numPerRetailer')
		}
	}, [isLoading.value])

	return {
		isLoading: isLoading.value,
		data: data.value,
		title: 'Num of ' + (catalogueAnalyzerTabSelected.value === GROUPED_BY.BRAND ? 'Brands' : 'Categories') + ' per Retailer',
		seriesName: catalogueAnalyzerTabSelected.value === GROUPED_BY.BRAND ? 'Nº Brands' : 'Nº Categories'
	}
}